import { useLocation, useNavigate } from 'react-router-dom';
import './style.scss';
import Login from './Login';

import ForgotPassword from './ForgotPassword';
import LandingWithoutLogin from '../LandingWithoutLogIn';
import SignUp from './SiginUp';
import useAuthContext from '../../hooks/useAuthContext';

const LoginSignInPage = () => {
  const location = useLocation();
  let navigate = useNavigate();
  let userIntension = location.pathname.split('/')[1];
  const {
    user: { userEmail },
    isAuthenticated,
  } = useAuthContext();
  const getIntetionTypeComponent = () => {
    if (isAuthenticated && userEmail) {
      navigate('/');
    } else {
      if (userIntension === 'login') {
        return <Login />;
      } else if (userIntension === 'signup') {
        return <SignUp />;
      } else if (userIntension === 'forgot-password') {
        return <ForgotPassword />;
      } else {
        return <LandingWithoutLogin />;
      }
    }
  };

  return (
    <div className="login_signin_page_wrapper">
      {getIntetionTypeComponent()}
    </div>
  );
};

export default LoginSignInPage;
